import React, { useEffect } from 'react'

import HomeDesktop from 'pages/Home/HomeDesktop/homeDesktop'
import HomeMobile from 'pages/Home/HomeMobile/homeMobile'
import { useHomePage } from 'hooks/useHomePage'
import { ModalLoadingCredit } from 'components/Loading'
import { BASE_PATH } from 'constants/general'
import { ModalError } from 'components/Error/ErrorModal'


export default function Home() {

    const { setAddCard, errorCode, loading, isMobile, setShowModalErr, sectionActive, showModalErr, messageResponse, montoCredito, aceptarCredito } = useHomePage()

    
    useEffect(() => {
        //- Codigo de instana para track de pagina
        window.ineum('page', 'Home Credit-Page')
        window.ineum('meta', 'portal', 'Credito')
    }, [])


    const handleCloseErr = () => {
        // valida creacion de ticket y si no pasa manda el error
        setShowModalErr(false);
        if (sectionActive === 'consultar') {
            window.location.replace(`${BASE_PATH}`)
        }
    }


    return (
        <>
            {loading && <ModalLoadingCredit />}
            {isMobile
                ? isMobile === 'desktop'
                    ? <HomeDesktop setAddCard={setAddCard} errorCode={errorCode} creditoAutorizado={montoCredito} isMobile={isMobile} aceptarCredito={aceptarCredito} loading={loading} />
                    : <HomeMobile setAddCard={setAddCard} errorCode={errorCode} creditoAutorizado={montoCredito} isMobile={isMobile} aceptarCredito={aceptarCredito} loading={loading}/>
                : null
            }

            {showModalErr &&
                <ModalError
                    errorCode={errorCode}
                    section={sectionActive}
                    message={messageResponse}
                    handleClose={handleCloseErr}
                />
            }
        </>
    )
}